import React from 'react';
interface CurvedDividerProps {
  /** Direction of the curve transition */
  direction: 'dark-to-light' | 'light-to-dark';
  /** Optional custom class name */
  className?: string;
}
/**
 * CurvedDivider component creates smooth visual transitions between sections
 * with different background colors using SVG curves.
 */
export function CurvedDivider({
  direction,
  className = ''
}: CurvedDividerProps) {
  const isDarkToLight = direction === 'dark-to-light';
  return <div className={`relative w-full ${className}`} style={{
    height: '120px'
  }} data-id="element-2178">
      <svg className="absolute bottom-0 w-full h-full" viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-2179">
        {isDarkToLight ?
      // Dark to Light transition
      <>
            {/* Background fill for dark section */}
            <path d="M0,0 L1440,0 L1440,120 L0,120 Z" fill="#121212" data-id="element-2180" />
            {/* Smooth curved transition to light */}
            <path d="M0,60 C240,30 480,45 720,60 C960,75 1200,45 1440,60 L1440,120 L0,120 Z" fill="#fafafa" data-id="element-2181" />
          </> :
      // Light to Dark transition
      <>
            {/* Background fill for light section */}
            <path d="M0,0 L1440,0 L1440,120 L0,120 Z" fill="#fafafa" data-id="element-2182" />
            {/* Smooth curved transition to dark */}
            <path d="M0,60 C240,30 480,45 720,60 C960,75 1200,45 1440,60 L1440,120 L0,120 Z" fill="#121212" data-id="element-2183" />
          </>}
      </svg>
    </div>;
}